export default __webpack_public_path__ + "static/media/CoffeeShop.9db4d4d3.jpg";